import { postRequest } from '../../../../utils'
import { CreateFolderActionOriginType } from '../../enums/createFolderActionOriginType'
import { dmsPath } from '../../query-api'

interface CreateFolderPayload {
  organizationId: string
  name: string
  parentFolderId: string | null
  origin: CreateFolderActionOriginType
}

export const createFolder = ({ organizationId, ...payload }: CreateFolderPayload) => {
  return postRequest(dmsPath(organizationId, '/folders'), payload)
}
